import { Theme, makeStyles } from '@material-ui/core';

const footerStyles = makeStyles<Theme>((theme) => {
  const mobileBreakpoint = theme.breakpoints.down('sm');
  const maxImgHeight =  'calc(48vh - 50px)';
  return ({
    footerNonMobile: {
      padding: '15px 0px 40px 48px',
      marginTop: 'auto',
      [mobileBreakpoint]: {
      }
    },
    footerMobile: {
    },
    footerPrivacyChoicesImage: {
      width: "30px",
      paddingLeft: '5px'
    }
  });
});

export default footerStyles;
